import { useEffect, useRef, useState } from 'react';

import { DatePicker } from 'antd';

import dayjs from 'dayjs';
import PropTypes from 'prop-types';

import css from './DatePicker.module.scss';

const CustomDateSomePicker = props => {
  const { /*disabledDays,*/ value, onChange, error, minDate, withSchedule } = props;
  const [loadedPicker, changeLoadedPicker] = useState(false);
  const [pickerValue, setPickerValue] = useState(dayjs());
  const modalRef = useRef();

  const onChangeDate = (date, stringDates) => {
    onChange(stringDates);
  };

  const handlePanelChange = newValue => {
    setPickerValue(newValue);
  };

  useEffect(() => {
    changeLoadedPicker(true);
    return () => changeLoadedPicker(false);
  }, [value]);

  return (
    <div ref={modalRef} className={css.DatePicker} id='datePickerCalendar' data-qa='datePickerCalendar'>
      {loadedPicker && (
        <DatePicker
          multiple
          open
          minDate={minDate}
          defaultValue={value?.map(e => dayjs(e))} // value?.filter(date => dayjs().isSameOrBefore(dayjs(date))).map(e => dayjs(e));
          value={value?.map(e => dayjs(e))}
          pickerValue={pickerValue}
          onPanelChange={handlePanelChange}
          maxTagCount='responsive'
          // disabledDate={disabledDays.before} // это надо доработать и стандартизировать в каком формате приходят данные их так же можно использовать в аргументах minDate maxDate
          classNames={{
            popup: `${css.DatePicker__poppup} ${error && css.error}`,
          }}
          className={css.DatePicker__input}
          onCalendarChange={onChangeDate}
          size={'middle'}
          getPopupContainer={() => modalRef.current}
          disabled={withSchedule}
        />
      )}
    </div>
  );
};

CustomDateSomePicker.propTypes = {
  date: PropTypes.array,
  error: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.array,
  minDate: PropTypes.any,
  withSchedule: PropTypes.bool,
};

export default CustomDateSomePicker;
